import { render, staticRenderFns } from "./recommendInner.vue?vue&type=template&id=3c602bb8&scoped=true&"
import script from "./recommendInner.vue?vue&type=script&lang=js&"
export * from "./recommendInner.vue?vue&type=script&lang=js&"
import style0 from "./recommendInner.vue?vue&type=style&index=0&id=3c602bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c602bb8",
  null
  
)

export default component.exports